export const ACTION = {
  RESET_STATE: 'RESET_STATE',
  BULK_OPERATION_SUCCESS: 'BULK_OPERATION_SUCCESS',
  SHOW_TOAST_INFO: 'SHOW_TOAST_INFO',
  HIDE_TOAST_INFO: 'HIDE_TOAST_INFO'

  // LOGOUT: 'LOGOUT',
};